import React from 'react';
import {useNavigate} from 'react-router-dom';
import {useTableSort} from '../../utils/sortUtilities';
import Spinner from '../Spinner';
import Table from '../Table';

const HEAD_CELLS = [
  {
    id: 'name',
    numeric: false,
    disabledPadding: true,
    label: 'Project Name',
  },
  {
    id: 'city',
    numeric: false,
    disabledPadding: false,
    label: 'City',
  },
  {
    id: 'address',
    numeric: false,
    disabledPadding: false,
    label: 'Address',
  },
  {
    id: 'created_at',
    numeric: false,
    disabledPadding: true,
    label: 'Created at',
  },
];

const DATA_CELLS = ['name', 'city', 'address', 'createdAt'];

const ComplexesTable = ({
  buildings,
  dataCells = DATA_CELLS,
  headCells = HEAD_CELLS,
  loading,
}) => {
  const navigate = useNavigate();
  const tableOrder = useTableSort('asc', 'created_at');

  const onRowClick = id => {
    navigate(`/projects/${id}`);
  };
  const rowHref = id => `/projects/${id}`;

  if (loading) {
    return <Spinner />;
  }

  return (
    <Table
      data={buildings}
      dataCells={dataCells}
      headCells={headCells}
      onRowClick={onRowClick}
      rowHref={rowHref}
      noToolbar
      {...tableOrder}
    />
  );
};

export default ComplexesTable;
